export const LOGIN_REQUEST = 'auth/LOGIN_REQUEST';
export const LOGIN_FAILURE = 'auth/LOGIN_FAILURE';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';

export const SIGNUP_REQUEST = 'auth/SIGNUP_REQUEST';
export const SIGNUP_FAILURE = 'auth/SIGNUP_FAILURE';
export const SIGNUP_SUCCESS = 'auth/SIGNUP_SUCCESS';

export const SIGNUP_CONFIRMATION_REQUEST = 'auth/SIGNUP_CONFIRMATION_REQUEST';
export const SIGNUP_CONFIRMATION_FAILURE = 'auth/SIGNUP_CONFIRMATION_FAILURE';
export const SIGNUP_CONFIRMATION_SUCCESS = 'auth/SIGNUP_CONFIRMATION_SUCCESS';

export const LOGOUT_REQUEST = 'auth/LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'auth/LOGOUT_SUCCESS';

export const FORGOT_REQUEST = 'auth/FORGOT_REQUEST';
export const FORGOT_FAILURE = 'auth/FORGOT_FAILURE';
export const FORGOT_SUCCESS = 'auth/FORGOT_SUCCESS';

export const FORGOT_CONFIRMATION_REQUEST = 'auth/FORGOT_CONFIRMATION_REQUEST';
export const FORGOT_CONFIRMATION_FAILURE = 'auth/FORGOT_CONFIRMATION_FAILURE';
export const FORGOT_CONFIRMATION_SUCCESS = 'auth/FORGOT_CONFIRMATION_SUCCESS';

export const VERIFY_REQUEST = 'auth/VERIFY_REQUEST';
export const VERIFY_FAILURE = 'auth/VERIFY_FAILURE';
export const VERIFY_SUCCESS = 'auth/VERIFY_SUCCESS';



// WEBPACK FOOTER //
// ./src/containers/Auth/constants.js